import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { getOtp } from '@/api/auth';

import { ERROR_CODE } from '@/constants/api';
import { ROUTE } from '@/constants/routes';

import { getAPIErrorCode, getMinorTriggeredByAdultName } from '@/utils/api';

import { CountrySelectionForm } from '../types/form';

type UseRequestOTPProps = {
  formValues: CountrySelectionForm;
  onEXCNotAllowed?: () => void;
};

export const useRequestOTP = ({
  formValues,
  onEXCNotAllowed,
}: UseRequestOTPProps) => {
  const navigate = useNavigate();
  const mutation = useMutation({
    mutationFn: getOtp,
    onSuccess: () => {
      navigate(ROUTE.LOGIN_VERIFY_EMAIL, {
        state: { from: ROUTE.LOGIN, form: formValues },
      });
    },
    onError: error => {
      const apiErrorCode = getAPIErrorCode(error);
      if (apiErrorCode === ERROR_CODE.EXC_IS_NOT_ALLOWED) {
        onEXCNotAllowed?.();
      } else if (
        apiErrorCode === ERROR_CODE.MINOR_TRIGGER_BY_ADULT_NOT_ALLOWED
      ) {
        const adultName = getMinorTriggeredByAdultName(error);
        navigate(ROUTE.MINOR_TRIGGERED_BY_ADULT, {
          state: adultName ? { adultName } : undefined,
        });
      }
    },
  });
  return mutation;
};
